import {TranslateSvc} from '../../../services/TranslateSvc';
import {CouponCompaniesNames} from '../../services/SubscriptionSvc';

export class SubscriptionCouponMessagesSvc {
    constructor(private TranslateSvc: TranslateSvc) {

    }

    get(discount: SubscriptionPredict.PriceDiscount) {
        const {campaign, discountType} = discount;
        switch (discountType) {
            case 'USER':
                return this.getMessageForUserType(discount);
            case 'REFERRAL':
                return this.getMessageForSpecialDiscount('Affiliate');
            case 'CAMPAIGN': {
                const companiesName = CouponCompaniesNames[campaign];
                return this.getMessageForSpecialDiscount(companiesName ?
                    companiesName.title : CouponCompaniesNames.defaultCompany.title
                );
            }
        }
    }

    private getMessageForUserType({
                                      amount,
                                      percents,
                                      durationInMonths,
                                      duration
                                  }: SubscriptionPredict.PriceDiscount) {
        const period = durationInMonths
            ? this.getPeriodFromMonths(durationInMonths)
            : this.TranslateSvc.get(`subscription.coupon.${duration}-discount-message`);
        const amountText = amount ? `${amount / 100}$` : `${percents}%`;

        return this.TranslateSvc.get(
            'subscription.coupon.applied-message',
            amountText,
            period
        );
    }


    private getMessageForSpecialDiscount(program: string) {
        return this.TranslateSvc.get(
            'subscription.coupon.special-discount-message',
            program
        );
    }

    private getPeriodFromMonths(months: number) {
        const years = months / 12;
        const isYear = years % 2 === 1;

        const getPeriod = (
            period: number,
            pluralText: string,
            singularText: string
        ) => {
            const yearText = period > 1 ? pluralText : singularText;
            return this.TranslateSvc.get(yearText);
        };

        if (isYear) {
            const periodText = getPeriod(years, 'years', 'year');
            return `${years} ${periodText}`;
        } else {
            const periodText = getPeriod(months, 'months', 'month');
            return `${months} ${periodText}`;
        }
    }
}

angular.module('animatronApp.SubscriptionCouponMessagesSvc', [])
    .service('subscriptionCouponMessageSvc', SubscriptionCouponMessagesSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/messages/SubscriptionCouponMessagesSvc.ts